import { Route, Routes } from "react-router-dom";
import AuthCallback from "./auth/AuthCallback";
import RequireAuth from "./auth/RequireAuth";
import MonitorPage from "./pages/MonitorPage";

export default function App() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <MonitorPage />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
